<template>
  <!-- 自定义tabbar -->
  <div class="tabBar">
    <div class="tabbar">
      <van-tabbar
        v-model="active"
        :style="{ backgroundColor: datas.backgroundColor }"
        :fixed="false"
        :placeholder="true"
        :border="datas.isShowBorder"
        :active-color="datas.activeColor"
        :inactive-color="datas.inactiveColor"
        :before-change="handleBeforeChange"
      >
        <van-tabbar-item
          v-for="(item, index) in datas.iconList"
          :key="index"
          :name="item.iconText"
          :dot="item.isDot"
          v-if="item.isActive"
        >
          <span>{{ item.iconText }}</span>
          <template #icon="props">
            <div v-if="props.active">
              <i
                v-if="item.iconPic.includes('iconfont')"
                :class="item.iconPic"
                style="font-size: 25px"
              ></i>
              <van-icon
                v-else
                :name="item.iconPic"
                :color="datas.activeColor"
                size="28"
              />
            </div>
            <div v-else>
              <i
                v-if="item.inactive.includes('iconfont')"
                :class="item.inactive"
                style="font-size: 25px"
              ></i>
              <van-icon
                v-else
                :name="item.inactive"
                :color="datas.inactiveColor"
                size="28"
              />
            </div>
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabbar1",
  props: {
    datas: Object,
    disabled: Boolean,
  },
  data() {
    return {
      active: 0,
    };
  },

  created() {},

  mounted() {
    // 当datas.iconList有值时，将底部导航栏数据存储到Vuex
  },

  methods: {
    // 切换前的拦截方法
    handleBeforeChange() {
      // 固定返回 false → 永远禁止切换
      return false;
    },
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
.tabBar {
  width: 100%;
  position: relative;
  // position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 2;
}

.tabbar {
  // :deep(.van-tabbar) {
  //   background-color: #999999 !important;
  // }
  :deep(.van-tabbar-item--active) {
    background-color: transparent !important;
  }
  ::v-deep .van-icon {
    width: 25px;
    height: 25px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
